import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const activeIRsGroupedByTypeRequest = createRequest(constants.activeIRsGroupedByType);
export const activeIRsGroupedByTypeSuccess = createSuccess(constants.activeIRsGroupedByType);
export const activeIRsGroupedByTypeFailure = createFailure(constants.activeIRsGroupedByType);

export const requestActiveIRsGroupedByType = activeIRsGroupedByTypeRequest;
